import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from '../axios';

export interface ChatStatusResponse {
  chatMaintenance: boolean;
}

export const getChatStatus = async () => {
  const { data } = await axios.get<ChatStatusResponse>(
    `${import.meta.env.VITE_CHAT_API}/v1/chat/status`,
    {
      headers: {
        'x-api-key': import.meta.env.VITE_X_API_KEY ?? '',
      },
    }
  );

  return data;
};

export const useChatStatusQuery = (enabled?: boolean) =>
  useQuery({
    queryKey: ['chatStatus'],
    queryFn: () => getChatStatus(),
    staleTime: 1000 * 60 * 5,
    enabled,
  });
